import * as React from 'react';
import translate from '../../locale/translate';
import assign = require('object-assign');

import { IInputChangeEventHandler } from '../../interfaces';

import { ReportTemplate } from '../../store/models';

interface IProps {
    className?: string,
    reportTemplate: ReportTemplate,
    onChange: IInputChangeEventHandler,
}

interface IState {
    name: string,
}

const VALID_CHANGE_PROPERTIES = ['name'];

export default class ReportPropertiesForm extends React.Component<IProps, IState> {
    static propTypes = {
        className: React.PropTypes.string,
        reportTemplate: React.PropTypes.object.isRequired,
        onChange: React.PropTypes.func.isRequired,
    };

    constructor(props: IProps) {
        super(props);

        this.componentWillReceiveProps(props);
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (nextProps.reportTemplate) {
            this.state = assign({}, nextProps.reportTemplate);
        }
    }

    onChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const target = evt.target;

        this.setState(assign({}, this.state, { [target.name]: target.value }));
    }

    onBlur() {
        Object.keys(this.state).forEach((key) => {
            if (VALID_CHANGE_PROPERTIES.indexOf(key) >= 0) {
                this.props.onChange(key, this.state[key]);
            }
        });
    }

    render() {
        let { className } = this.props;
        const { onChange, reportTemplate } = this.props;

        className = `${className} form-horizontal`;

        return (
            <form className={className}>
                <div className="form-group m-b-n">
                    <label className="col-sm-2 control-label">
                        {translate.gettext('Template name')}
                    </label>
                    <div className="col-sm-10">
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={this.state.name}
                            onChange={this.onChange.bind(this)}
                            onBlur={this.onBlur.bind(this)} />
                    </div>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reportProperties/Form.tsx